import React from "react";

import { UtilityPage } from "./styles";
import UtilityCard from "./components/UtilityCard";
import { UTILITIES } from "constants";

function Utilities() {
  return (
    <UtilityPage>
      {UTILITIES.map((utility, index) => (
        <UtilityCard
          key={index}
          disabled={utility.disabled}
          url={utility.url}
          title={utility.title}
          subtitle={utility.subtitle}
        />
      ))}
    </UtilityPage>
  );
}

export default Utilities;
